const baseUrl = `${window._env_.REACT_APP_API_URL}${
  window._env_.REACT_APP_API_PORT == ""
    ? ""
    : `:${window._env_.REACT_APP_API_PORT}`
}`;

const urlServiceProvider = { baseUrl };

export default urlServiceProvider;
